// firebase.ts
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
const firebaseConfig = {
    apiKey: "AIzaSyD-pMiuEQSdLao_73oh2CakKRXvA10RDT4",
    authDomain: "ink-clientzone.firebaseapp.com",
    projectId: "ink-clientzone",
    storageBucket: "ink-clientzone.firebasestorage.app",
    messagingSenderId: "856421924200",
    appId: "1:856421924200:web:b55e772ae7003db6e26add"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const funcs = getFunctions(app, 'us-central1');
export function userDocRef(uid) {
    return doc(db, "users", uid);
}
export async function isAdminByFirestore(uid) {
    const d = await getDoc(userDocRef(uid));
    return !!(d.exists() && d.data().role === "admin");
}
// return role string or null
export async function getUserRole(uid) {
    console.debug('[getUserRole] uid=', uid);
    try {
        const d = await getDoc(userDocRef(uid));
        console.debug('[getUserRole] doc.exists=', d.exists());
        if (!d.exists()) {
            console.debug('[getUserRole] no user doc for uid', uid);
            return null;
        }
        const data = d.data();
        console.debug('[getUserRole] doc.data=', data);
        return data?.role ?? null;
    }
    catch (e) {
        console.error('[getUserRole] error code=', e?.code, 'message=', e?.message, e);
        throw e;
    }
}
// debug helper: logs ID token claims for current signed-in client
export async function getIdTokenClaims() {
    const user = auth.currentUser;
    if (!user) {
        console.debug('[getIdTokenClaims] no currentUser');
        return null;
    }
    try {
        const tokenResult = await user.getIdTokenResult(true);
        console.debug('[getIdTokenClaims] uid=', user.uid, 'claims=', tokenResult.claims);
        return tokenResult.claims;
    }
    catch (e) {
        console.error('[getIdTokenClaims] error', e?.code, e?.message);
        return null;
    }
}
